// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hUWP","comment":"styles_comment__2pUsr"};